import { Checkbox, Form, Input, Button, Modal, Spin, Typography } from 'antd';
import React, { useState, useEffect, useContext, useRef } from 'react';
import category12 from '../../../../src/assets/images/category12.png';
import { MultiStepFormData } from '../../Authentication/MultiStepForm/MultiStepForm';
import { fetchData } from '../../../Services/FetchData';
import usecustomStyles from '../../../Common/customStyles';
import { API_ENDPOINTS } from '../../../constants/apiEndPoints';
import { useSelector } from 'react-redux';
import { PlaceholderContent } from '../../../constants/Placeholder';

const customStyles = usecustomStyles();
const { Text } = Typography;
let placeholderContent = PlaceholderContent?.SIGNUP_STEPS;

const BusinessCategory = ({ getCategories, selectedCategory }) => {
  const FormData = useContext(MultiStepFormData);
  const [checkedItem, setCheckedItem] = useState(null);
  const [category, setCategory] = useState([]);
  const [loading, setLoading] = useState(true);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [categoriesSelected, setCategoriesSelected] = useState('');
  const [otherCategoriesSelected, setOtherCategoriesSelected] = useState('');
  const [otherCategoryTyped, setOtherCategoryTyped] = useState('');
  const otherCategory = useRef(null);
  const [otherCategoryDataRemoved, setOtherCategoryDataRemoved] = useState(false);
  const otherCategoryInput = useRef(null)
  const [othersData, setOthersData] = useState('');
  const [otherBtnDisable, setOtherBtnDisable] = useState(true);
  const data = useSelector((state) => state.BusinessInfoReducer?.businessInfo?.business_category)
  const [prefilledCategory, setPrefilledCategory] = useState();
  useEffect(() => {
    const getBusinessCategories = async () => {
      try {
        const endPoint = API_ENDPOINTS.BUSINESS_INFO.CATEGORIES;
        const fetchedData = await fetchData(endPoint);
        setCategory(fetchedData);
      } catch (error) {
        console.error(error);
      } finally {
        setLoading(false);
      }
    };
    getBusinessCategories();
  }, []);
  useEffect(() => {
    let otherData = FormData?.formData?.otherCategories;
    if (otherData) {
      setOthersData(otherData)
      // otherCategory?.current?.classList?.add('active')
    }
  }, [FormData])

  useEffect(() => {
    if (category.length > 0) {
      getCategories(category);
      setLoading(false);
      setOthersData(category.filter((el, index) => el?.title === 'Other'))
    }
  }, [category, getCategories]);

  useEffect(() => {
    if (checkedItem) {
      const checkboxSelected = category.find((el) => el._id === checkedItem);
      setCategoriesSelected(checkboxSelected?.title || '');
    }
  }, [checkedItem, category]);


  useEffect(() => {
    if (otherCategoriesSelected) {
      selectedCategory(otherCategoriesSelected)
    }
    else {
      selectedCategory(categoriesSelected)
    }
  }, [categoriesSelected, otherCategoriesSelected])

  useEffect(() => {
    if (data) {
      setPrefilledCategory(data)

      FormData.setFormVerified({
        ...FormData.formVerified,
        [FormData.page]: true
      });

    }
  }, [data])

  useEffect(() => {
    if (category?.length > 0 && data) {
      let filteredData = category.filter((el, index) => {
        return data === el?.title;
      });
      console.log('filteredData?.length', filteredData?.length)
      if (filteredData?.length > 0) {
        FormData.setFormData({
          ...FormData.formData,
          businessCategories: data
        });
      }
      else {
        FormData.setFormData({
          ...FormData.formData,
          otherCategories: data
        });
        setOtherCategoriesSelected(data)
        setOtherCategoryTyped(data)
      }

    }
  }, [category, data])

  useEffect(() => {
    let categoryFilter = category.filter((el) => el?.title === data);
    if (categoryFilter?.length === 0 && otherCategory.current && !checkedItem) {
      // otherCategory.current.classList.add('active')
      addCategoryForm.setFieldValue({ other_category_value: 'safdafdafdas' })
      setOtherCategoriesSelected(data);
      setOtherCategoryTyped(data)
      FormData.setFormData({
        ...FormData.formData,
        otherCategories: data
      });
    }
    else {
      if (otherCategory.current) {
        otherCategory.current.classList.remove('active')
        setOtherCategoriesSelected();
      }

    }
  }, [category, data, otherCategory, checkedItem])

  // useEffect(() => {
  //   if (data) {
  //     FormData.setFormVerified({
  //       ...FormData.formVerified,
  //       [FormData.page] : true
  //     });
  //   }

  // }, [ FormData])
  // useEffect(() => {
  //   console.log('prefilled category:', prefilledCategory);
  //   let filteredData = []; // Initialize with an empty array

  //   if (prefilledCategory) {
  //     if (Array.isArray(category) && category.length > 0) {
  //       filteredData = category.filter((el, index) => {
  //         console.log(`Title of item ${index}:`, el.title);
  //         console.log('prefilledCategory:', prefilledCategory);
  //         return prefilledCategory === el?.title;
  //       });
  //       if (filteredData.length) {
  //         FormData.setFormData({
  //           ...FormData.formData,
  //           businessCategories: prefilledCategory
  //         });
  //       } else {
  //         FormData.setFormData({
  //           ...FormData.formData,
  //           otherCategories: prefilledCategory
  //         });
  //       }
  //     } else {
  //       console.warn('Category array is empty or undefined');
  //     }
  //   } else {
  //     console.warn('No prefilled category provided');
  //   }


  // }, [prefilledCategory, category]);



  const handleCheckboxChange = (id, element) => {
    setPrefilledCategory('');
    setOtherCategoriesSelected('');
    setOtherCategoryTyped('');
    setCheckedItem(id);



    // Remove 'active' class from other category button if it exists
    if (otherCategory.current) {
      otherCategory.current.classList.remove('active');
    }

    // Update form data and form verification status
    FormData.setFormData({
      ...FormData.formData,
      otherCategories: '',
      businessCategories: element?.title,
    });
    FormData.setFormVerified({
      ...FormData.formVerified,
      [FormData.page]: Boolean(id),
    });
  };

  const showModal = () => {
    setIsModalOpen(true);
    setCheckedItem(null)
    if (otherCategoriesSelected?.length > 3) {
      setOtherCategoryTyped(otherCategoriesSelected)
    }
    if (!otherCategoriesSelected) {
      FormData.setFormVerified({
        ...FormData.formVerified,
        [FormData.page]: false
      });
    }

  };

  const handleOk = () => {

    setOtherCategoriesSelected(otherCategoryTyped)
    setIsModalOpen(false);

    FormData.setFormData({
      ...FormData.formData,
      businessCategories: ''
    });

  };

  const handleCancel = () => {
    addCategoryForm.resetFields();

    if (!otherCategoriesSelected) {
      FormData.setFormData({
        ...FormData.formData,
        otherCategories: ''
      });
      FormData.setFormVerified({
        ...FormData.formVerified,
        [FormData.page]: false
      });
    }
    // setOtherCategoriesSelected('')
    setIsModalOpen(false);
    setOtherCategoryTyped('')
    if (!data) {
      addCategoryForm.resetFields()
    }
    // setOtherBtnDisable(true)

    if (!otherCategoriesSelected?.length > 3) {
      otherCategory.current.classList.remove('active')
    }
    else {
      setOtherCategoryTyped(otherCategoriesSelected)
    }


  };

  const onChange = (e) => {

    // setPrefilledCategory('')
    FormData.setFormData({
      ...FormData.formData,
      businessCategories: ''
    });
    FormData.setFormData({
      ...FormData.formData,
      otherCategories: e.target.value
    });
    FormData.setFormVerified({
      ...FormData.formVerified,
      [FormData.page]: e.target.value?.length > 2 || !!checkedItem
    });

    if (e.target.value.length < 3) {
      setOtherBtnDisable(true)
    }
    // if (e.target.value.length > 2) {
    //   setOtherBtnDisable(false)
    // }
    // else {
    //   setOtherBtnDisable(true)
    // }
    setOtherCategoryTyped(e.target.value)


    // if (e.target.value) {
    //   // setCategoriesSelected(e.target.value)  
    //   otherCategory.current.classList.add('active')
    // }
    // else {
    //   otherCategory.current.classList.remove('active')
    // }

  };

  useEffect(() => {
    if (otherCategory?.current) {
      if (otherCategoriesSelected?.length > 3) {
        FormData.setFormData({
          ...FormData.formData,
          businessCategories: '',
        });
        FormData.setFormData({
          ...FormData.formData,
          businessCategories: otherCategoriesSelected,
        });
        setPrefilledCategory('')
        otherCategory.current.classList.add('active')
      }
      else {
        otherCategory.current.classList.remove('active')
      }
    }

    // if(otherCategoryTyped?.length > 3){
    //   otherCategory.current.classList.remove('active')
    // }
  }, [otherCategoriesSelected, otherCategoryTyped])
  useEffect(() => {
    console.log('otherBtnDisable', otherBtnDisable)
  }, [otherBtnDisable])

  useEffect(() => {
    console.log('otherCategoryTyped', otherCategoryTyped)
    if (otherCategoriesSelected) {
      FormData.setFormVerified({
        ...FormData.formVerified,
        [FormData.page]: true
      });
    }
    if (otherCategoryTyped?.length > 3 ) {
      setOtherBtnDisable(false)
    }
    else {
      setOtherBtnDisable(true)
    }

  }, [otherCategoryTyped, otherCategoriesSelected])



  const [addCategoryForm] = Form.useForm();

  return (
    <div className='business_category_selection'>
      <form className="checkbox_wrap form_body business_category">
        {loading && (
          <div className="spinner center">
            <Spin />
          </div>
        )}
        {category.map((el) => (
          el.title !== 'Other' ? (
            <Checkbox
              key={el._id}
              checked={(checkedItem ? checkedItem === el._id : prefilledCategory === el?.title)}
              onChange={() => handleCheckboxChange(el._id, el)}
              value={el.title}
            >
              <div className="checkbox_body">
                <span><img src={el.icon_url} alt={el.title} loading="lazy" /></span>
                <span className='md'>{el.title}</span>
              </div>
            </Checkbox>
          ) : null
        ))}
        {othersData && (<div className='other_wrap'>
          <Button
            className="default_btn_remove other_category"
            ref={otherCategory}
            style={{ border: "unset", height: "100%", fontSize: "calc(11px + 0.5rem)", padding: 0 }}
            type="button"
            onClick={showModal}
          >
            <div className="checkbox_body">
              <span><img src={othersData[0]?.icon_url} alt={othersData[0]?.icon_url} loading="lazy" /></span>
              <span className='md'>{othersData[0]?.title}</span>
            </div>
            <span className="selected_others_category"></span>
          </Button>
          <span className='semibold md other_data' style={{ paddingTop: '10px' }}>{otherCategoriesSelected}</span>
        </div>)}

      </form>
      <Modal
        open={isModalOpen}
        onCancel={handleCancel}
        closable={false}
        className="other_business_category"
        footer={[
          <Button key="back" onClick={handleCancel}>
            Cancel
          </Button>,
          <Button key="submit" type="primary" onClick={handleOk} disabled={otherBtnDisable}>
            Continue
          </Button>,
        ]}
      >        <div className="modal_wrap form_wrap categories_modal">
          <div className="text-center" style={{ margin: "20px 0" }}>
            <h5 style={{ fontSize: "calc(1.5vw + 5px)", color: customStyles.colorPrimary }}>Add New Category</h5>
            <p style={{ fontSize: "calc(.8vw + 3px)" }}>See how your Ad looks in the Lumi App.</p>
          </div>
          <Form
            form={addCategoryForm}
            className="form_body text-center"
            style={{ padding: 0 }}

            onSubmit={(event) => {
              event.preventDefault();
            }}
          >
            <div style={{ marginLeft: "auto", marginRight: "auto", maxWidth: "509px" }}>
              <label htmlFor="" className="text_red d-block sm">Category Name</label>
              <Form.Item
                rules={[
                  {
                    required: true,
                    message: 'Please enter a valid category name.',
                  }
                ]}
              >
                <Input
                  name="other_category_value"
                  placeholder={placeholderContent?.BusinessName}
                  style={{ margin: "10px auto", color: "#9E9E9E", textAlign: "center", boxShadow: 'none', outline: 'none', height: 'calc(1vw + 38px)' }}
                  type="text"
                  value={otherCategoryTyped}
                  onChange={onChange}
                  maxLength={70}
                  ref={otherCategoryInput}
                />
              </Form.Item>
            </div>
          </Form>
        </div>
      </Modal>
    </div>
  );
};

export default BusinessCategory;
